import React, { ChangeEvent, FormEvent, useState } from 'react'
import driverLogo from '../assets/driver-logo.png'
import licenseCardImg from '../assets/license-card-pic.png'
import QuestionList from '../components/question-list'
import CustomButton from '../components/custom-button'
import CustomInput from './custom-input'
import UseChaseProvider from '../utils/use-chase-provider'
import axiosInstance from '../utils/axiosInstance'
import { toast } from 'react-toastify'
import { ParseErrors } from '../utils/parse-errors'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

const SEGMENT_CLASS = "min-w-0 bg-app-field text-center font-code font-bold text-[16px] tracking-[0.06em] uppercase text-white outline-none border border-white/[0.12] w-full h-[48px] rounded-xl transition-[border-color,box-shadow] duration-200 placeholder:text-white/[0.55] hover:border-white/[0.22] focus:border-brand-accent focus:shadow-focus focus-visible:outline-none"


const getLastName = (name: string) => {
    let lastname = name.split('')
    const arrayLength = lastname.length

    if (lastname.length < 5) {
        for (let i = 0; i < 5 - arrayLength; i++) {
            lastname.push('9')
        }
    }

    return lastname.join("")
}


const ChaseInputItem: React.FC = () => {
    const { chase, chaseType, onSetChaseType, driverId, onSetDriverId } = UseChaseProvider()
    const [nationalInsuranceNumber, setNationalInsuranceNumber] = useState({
        setOne: !driverId ? (chase?.surname?.length! >= 5 ? chase?.surname?.slice(0, 5)?.toUpperCase() : getLastName(chase?.surname!))?.toLocaleUpperCase() : "",
        setTwo: !driverId ? (`${chase?.dob?.split('-')[0].slice(2, 3)}${chase?.gender === "male" ? chase?.dob?.split("-")[1] : Number(chase?.dob?.split("-")[1].split("")[0]) + 5 + "" + chase?.dob?.split("-")[1].split("")[1]}${chase?.dob?.split("-").pop()}${chase?.dob?.split('-')[0].slice(3, 4)}`) : "",
        setThree: `${chase?.firstName.slice(0, 2).toUpperCase()}`,
        setFour: "9NH"
    })
    const [values, setValues] = useState({
        nationalInsuranceNumber: "",
        driversLicenceNumber: "",
        postCode: ""
    })
    const [loading, setLoading] = useState<boolean>(false)
    const chaseDriver = driverId ? chase?.drivers?.find((driver) => driver.id === driverId) : null
    const chaseDriverName = driverId ? chaseDriver?.name : chase?.firstName + " " + chase?.surname


    const HandleSubmitInputValues = async (e: FormEvent) => {
        e.preventDefault()
        setLoading(true)
        try {
            await axiosInstance.patch(`/chase/public/${chase?.policyReferenceNumber}`, {
                chaseType: chaseType,
                chaseBodyData: [{ ...values, nationalInsuranceNumber: nationalInsuranceNumber?.setOne! + nationalInsuranceNumber?.setTwo! + nationalInsuranceNumber?.setThree + nationalInsuranceNumber?.setFour }],
                chaseBodyDataType: "inputs",
                driverId,
            })
            toast.success("Updated Successfully")
            setLoading(false)
            onSetChaseType()
            onSetDriverId()
        } catch (error: any) {
            toast.error(ParseErrors(error))
            setLoading(false)
        }
    }


    // -------------------------- [ SET VALUES ] ---------------------------------
    const onChangeValues = (e: ChangeEvent<HTMLInputElement>) => {
        setValues((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }

    // ----------------------- [ SET NATIONAL NUMBER ] --------------------------------
    const onChangeNationalNumber = (e: ChangeEvent<HTMLInputElement>, prop: string) => {
        setNationalInsuranceNumber((prev) => ({ ...prev, [prop]: e.target.value }))
    }
    return (
        <div className='mt-6'>
            <QuestionList number={2} >
                <div className='w-full flex items-center justify-between gap-3 px-3 py-3 sm:px-4 -mt-1 surface-row'>
                    {/* Profile */}
                    <div className='flex items-center justify-start min-w-0'>
                        <span className='min-w-[48px] h-[48px] rounded-tile bg-white border border-white/[0.15] flex items-center justify-center mr-3'>
                            <img src={driverLogo} alt='' className='w-[24px] h-auto' />
                        </span>
                        <div className='min-w-0'>
                            <p className='text-pill uppercase m-0 p-0 text-white/[0.66]'>{driverId ? "Additional Driver" : "Main Driver"}</p>
                            <h2 className='text-title mt-1 text-white m-0 p-0 truncate capitalize'>{chaseDriverName}</h2>
                        </div>
                    </div>
                    {/* Profile */}

                    <span className='min-w-[24px] h-[24px] rounded-full bg-success text-white flex items-center justify-center animate-pop'>
                        <FontAwesomeIcon icon={faCheck} className='text-[11px]' />
                    </span>
                </div>

            </QuestionList>

            <div className='w-full mt-6'>
                <p className='text-white font-bold text-[15px] pl-1'>Driver License Number</p>

                <div className='w-full mt-2.5 grid grid-cols-[22fr_32fr_23fr_23fr] gap-1.5 sm:gap-2'>
                    <input aria-label='Licence number, part 1' placeholder="JADEI" defaultValue={nationalInsuranceNumber.setOne} onChange={(e) => onChangeNationalNumber(e, 'setOne')} className={SEGMENT_CLASS} />
                    <input aria-label='Licence number, part 2' placeholder="795711" defaultValue={nationalInsuranceNumber.setTwo} onChange={(e) => onChangeNationalNumber(e, 'setTwo')} className={SEGMENT_CLASS} />
                    <input aria-label='Licence number, part 3' placeholder={nationalInsuranceNumber.setThree} onChange={(e) => onChangeNationalNumber(e, 'setThree')} className={SEGMENT_CLASS} />
                    <input aria-label='Licence number, part 4' placeholder={nationalInsuranceNumber.setFour} onChange={(e) => onChangeNationalNumber(e, 'setFour')} className={SEGMENT_CLASS} />
                </div>
            </div>


            <div className='w-full p-5 sm:p-6 mt-6 surface-row'>
                <h2 className="text-titleSM text-white">Driver License Number</h2>
                <p className='text-[14px] leading-[22px] mt-1.5 text-white/[0.66]'>Enter the last five characters of your driver’s license. We’ve pre-filled the start of it for you.</p>

                <img src={licenseCardImg} className='w-full mt-4 rounded-tile border border-white/[0.15] shadow-card opacity-95' alt='License Sample' />
            </div>



            {/* ----------------------------- [ INPUT FORMS ] --------------------------- */}
            <form className='mt-6' onSubmit={HandleSubmitInputValues}>
                <CustomInput label={'NI Number'} required name='driversLicenceNumber' onChange={onChangeValues} placeholder='QQ123456C' tooltip='Hello' pattern="[A-CEGHJ-PR-TW-Z]{1}[A-CEGHJ-NPR-TW-Z]{1}[0-9]{6}[A-D\s]$" />
                <div className='my-5'></div>
                <CustomInput label={'Post Code'} required name='postCode' onChange={onChangeValues} placeholder='E1 7DB' tooltip='Hello' pattern="(GIR ?0AA|[A-Z]{1,2}[0-9][0-9A-Z]? ?[0-9][A-Z]{2})$" />
                <div className='mt-6'></div>
                <CustomButton id='submit' loading={loading}>Submit</CustomButton>
            </form>
            {/* ----------------------------- [ INPUT FORMS ] --------------------------- */}

        </div>
    )
}

export default ChaseInputItem
